import { createContext } from 'react';
import type { UseChatSessionResult } from './useChatSession';

// Holds the live chat above the routing tree.
//
// ChatWidget is hidden on some routes (/admin/*, /ai-workspace, the rater), and
// while the session lived inside that component, navigating to one of them
// destroyed an in-progress conversation. Owning the session above the gate means
// the panel can unmount without dropping the contact.
export const ChatSessionContext = createContext<UseChatSessionResult | null>(null);
